import { Card, Skeleton, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import { useContext } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useNavigate } from "react-router-dom";
import LoaderContext from "../../Context/LoaderContext/Index";
import ProfileMatcherService from "../../Services/profile.matcher.service";
import DetailedRequirementList from "./DetailedRequirementList";
import { DashboardContext } from "../../Context/DashboardContext";
import ModalContext from "../../Context/ModalContext/Index";
import AgentService from "../../Services/agent/agent.service";
import InterviewService from "../../Services/interview.service";
import JobApplicationService from "../../Services/job.application.service";
import ResumeUploader from "../../Components/ResumeUploader";
import { RequirementsHandlers } from "./requirements.handlers";
import "./index.scss";

const { Title, Paragraph } = Typography;

const Requirements = () => {
  const navigate = useNavigate();

  const { showUploadCV, handleToggleModal } = useContext(ModalContext);
  const {
    appliedJob,
    jobDescription,
    addSession,
    enableRounds,
    enabledInterviewRoundTabs,
    setAppliedJob,
    setShowResultTab,
    setShowOnlineInterviewTab,
  } = useContext(DashboardContext);
  const { setLoading, setLoadingMessage } = useContext(LoaderContext);

  const handlers = new RequirementsHandlers({
    navigate,
    profileMatcherService: new ProfileMatcherService(),
    agentService: AgentService.getInstance(),
    interviewService: new InterviewService(),
    jobApplicationService: new JobApplicationService(),
    appliedJob,
    jobDescription,
    enabledInterviewRoundTabs,
    setAppliedJob,
    setShowResultTab,
    setShowOnlineInterviewTab,
    setLoading,
    setLoadingMessage,
    enableRounds,
    addSession,
  });

  return (
    <>
      <div>
        {jobDescription ? (
          <Content>
            {jobDescription.description && (
              <Paragraph>{jobDescription?.description}</Paragraph>
            )}
            {jobDescription.requirements &&
              jobDescription.requirements.length > 0 && (
                <div>
                  <Title level={5}>Requirements</Title>
                  <DetailedRequirementList
                    requirements={jobDescription.requirements}
                    appliedJob={appliedJob || null}
                  />
                </div>
              )}
          </Content>
        ) : (
          <Card className="requirements_container" bordered={false}>
            <Skeleton active paragraph={{ rows: 4 }} />
          </Card>
        )}
      </div>
      <ResumeUploader
        handleContinueWithProfile={handlers.handleContinueWithProfile}
        handleFileUploadAndAnalyze={handlers.handleFileUploadAndAnalyze}
        handleClose={handleToggleModal}
        isOpen={showUploadCV}
      />
    </>
  );
};

export default Requirements;
